import React from "react";
import { observer } from "mobx-react";

import { TSuggestedTournament } from "@data-types/suggested-search/SuggestedTournament";
import { useRootAppStore } from "@hooks";
import { SearchAction } from "@state/stores/offer/search/SearchStore";
import OfferIcons from "@components/icons/Offer";
import { useFormContext } from "react-hook-form";

export const SuggestedListTournament = observer(
	function SuggestedListTournament(props: { item: TSuggestedTournament }) {
		const store = useRootAppStore().searchStore;
		const form = useFormContext();

		return (
			<li
				onClick={(event) => {
					event.stopPropagation();
					event.preventDefault();

					const searchResult = store.searchSuggestedItem(
						SearchAction.PICK,
						{
							displayText: store.searchTerm,
							tournamentId: props.item.tournamentId,
						}
					);

					if (searchResult) {
						form.reset();
					}

					store.setIsSuggestedListOpen(false);
				}}
				className="popup--search__item"
			>
				<div className="popup--search__thumbs">
					<OfferIcons
						type="sport"
						sport={props.item.sport.abrv || ""}
						wrapperClassName="popup--search__icon popup--search__sport u-icon"
						className="u-icon u-icon--base"
					/>

					<OfferIcons
						type="tournament"
						sport={props.item.sport.abrv}
						category={props.item.category?.abrv || ""}
						tournament={props.item.details?.abrv || ""}
						wrapperClassName="popup--search__icon popup--search__trophy u-icon"
						className="u-icon u-icon--base"
					/>
				</div>
				<span className="popup--search__name">
					{props.item.details.name}
				</span>
			</li>
		);
	}
);
